import './App.css';
import { Navbar } from './components/Navbar';

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import HomePage from "./routes/HomePage";
import Footer from './components/Footer';
import About from './routes/About';
import Services from './routes/Services';
import ThankYou from './routes/ThankYou';
import Gallery from './routes/Gallery';
import { createContext, useEffect, useState } from 'react';
import { auth, firestore } from './api/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { MailManager } from './libraries/Web-Legos/api/mail.ts';
import { CmsManager } from './libraries/Web-Legos/api/cms.ts';
import { configureAuthClient, configureFormsClient } from './libraries/Web-Legos/api/services.ts';
import { AuthenticationManager, WLPermissionsConfig } from "./libraries/Web-Legos/api/auth.ts"
import { AnalyticsManager } from './libraries/Web-Legos/api/analytics.ts';
import { umamiConfigFor } from './libraries/Web-Legos/api/umamiRegistry.ts';

export const serverURL = '/';

export const CurrentSignInContext = createContext(null);

export const BTBMailManager = new MailManager({ site: "beyond-the-bell" });
BTBMailManager.addRecipientEmail("joedobbelaar@gmail.com");
BTBMailManager.addRecipientEmail("nancy@beyondthebelleducation.com");

CmsManager.configure({ site: "beyond-the-bell" });
configureAuthClient({ site: "beyond-the-bell" });
configureFormsClient({ site: "beyond-the-bell" });

export const AuthenticationManagerContext = createContext(null);

const analyticsManager = new AnalyticsManager(umamiConfigFor("beyond-the-bell"));
analyticsManager.initialize();

function App() {

  const permissions = new WLPermissionsConfig({
    testimonials: "testimonials",
    offerings: "offerings",
    staff: "staff",
  })
  const authenticationManager = new AuthenticationManager(
    {
      apiKey: "AIzaSyCIZYHsbNNMhRviRcaeyrpYDQ73AwLrapk",
      authDomain: "beyond-the-bell-20097.firebaseapp.com",
      projectId: "beyond-the-bell-20097",
      storageBucket: "beyond-the-bell-20097.appspot.com",
      messagingSenderId: "977570434108",
      appId: "1:977570434108:web:7a2ba50a64da35619ec739"
    },
    permissions
  )
  authenticationManager.initialize()

  const [currentSignIn, setCurrentSignIn] = useState(null);

  analyticsManager.logPageView("home");

  return (
    <AnalyticsManager.Context.Provider value={{analyticsManager}} >
    <AuthenticationManagerContext.Provider value={{authenticationManager}} >
    <CurrentSignInContext.Provider value={{currentSignIn, setCurrentSignIn}} >
      <div className="App d-flex flex-column align-items-center w-100">
      <Router>
        <div className="app-content">
          <Navbar />
            <Routes>
              <Route path="*" element={<HomePage />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/gallery" element={<Gallery />} />
            </Routes>
          <Footer />
        </div>
      </Router>
      </div>
    </CurrentSignInContext.Provider>
    </AuthenticationManagerContext.Provider>
    </AnalyticsManager.Context.Provider>
  );
}

export default App;
